import { render, staticRenderFns } from "./TabBarController.vue?vue&type=template&id=e86ed074"
import script from "./TabBarController.vue?vue&type=script&lang=ts"
export * from "./TabBarController.vue?vue&type=script&lang=ts"
import style0 from "./TabBarController.vue?vue&type=style&index=0&id=e86ed074&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports